import classnames from 'classnames';
import styles from "./index.module.scss";

export const CaretDownIcon = ({ open }: { open?: boolean }) => {
  return (
    <div className={classnames(styles['icon-caret-down'], {
      [styles['icon-caret-down--open']]: open,
    })}>
      <svg
        width="11"
        height="7"
        viewBox="0 0 11 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.78125 5.71875L0.78125 1.71875C0.5 1.4375 0.40625 1 0.5625 0.625C0.71875 0.25 1.09375 0 1.5 0H9.5C9.90625 0 10.25 0.25 10.4062 0.625C10.5625 1 10.4688 1.4375 10.1875 1.71875L6.1875 5.71875C5.8125 6.125 5.15625 6.125 4.78125 5.71875Z"
          fill="#353535"
        />
      </svg>
    </div>
  );
};
